import BreadCrumb from "Components/Common/BreadCrumb";
import "react-toastify/dist/ReactToastify.css";
import { Card, Container, Nav, NavItem, NavLink } from "reactstrap";
import "./manual-order.scss";
import { SetStateAction, useEffect, useState } from "react";
import ConfirmOrderModal from "./components/ConfirmOrderModal";
import OrderHistoryCard from "./components/OrderHistoryCard";
import classnames from "classnames";
import axios from "axios";
import TrackOrder from "./components/TrackOrder";
import TrackOrderMOdal from "./components/TrackOrder";
import { ToastContainer } from "react-toastify";

const MandualOrder = (props: any) => {

    document.title = "Orders | BuyPass";
    const [counts, setCounts] = useState<any>();
    const [searchTerm, setSearchTerm] = useState("");
    const [orders, setOrders] = useState<any>();
    const [activeTab, setActiveTab] = useState("all");
    var [statusTab, setStatusTab] = useState("all");
    const headerNavigations = [
        {
            label: "All Orders",
            value: "all",
            active: true,
            count: counts?.allCount,    
        },
        {
            label: "Pending",
            value: "pending",
            active: false,
            count: counts?.pendingCount,
        },
        {
            label: "Ready To Ship",
            value: "readyToShip",
            active: false,
            count: counts?.readyToShipCount,
        },
        {
            label: "Accepted",
            value: "accepted",
            active: false,
            count: counts?.acceptedCount,
        },
        {
            label: "Rejected",
            value: "rejected",
            active: false,
            count: counts?.rejectedCount,
        },
        {
            label: "Delivered",
            value: "delivered",
            active: false,
            count: counts?.deliveredCount,
        },
        {
            label: "Cancelled",
            value: "cancelled",
            active: false,
            count: counts?.cancelledCount,
        },
        {
            label: "Return",
            value: "return",
            active: false,
            count: counts?.returnCount,
        },
    ];
    const [ConfirmModal, setConfirmModal] = useState(false);
    const [proofModal, setProofModal] = useState(false);
    const [navigations, setNavigations] = useState(headerNavigations[0]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(1);
    const itemsPerPage = 10;

    const onGetOrders = async (page: number) => {
        try {
            const response = await axios.get(
                `api/v1/order/sellerorders?page=${page}&count=${itemsPerPage}&status=${statusTab}&keyword=${searchTerm}`
            );
            if (response?.data) {
                setOrders(response.data.data);
                setCounts(response.data.counts);
                setTotalPages(Math.ceil(response.data.totalCount / itemsPerPage));
            }
        } catch (err: any) {
        } finally {
        }
    };

    const onGetOrdersWithStatus = async (page: number, status: any) => {
        try {
            const response = await axios.get(
                `api/v1/order/sellerorders?page=${page}&count=${itemsPerPage}&status=${status}&keyword=${searchTerm}`
            );
            if (response?.data) {
                setOrders(response.data.data);
                setCounts(response.data.counts);
                setTotalPages(Math.ceil(response.data.totalCount / itemsPerPage));
            }
        } catch (err: any) {
        } finally {
        }
    };

    useEffect(() => {
        onGetOrders(currentPage);
    }, [searchTerm, currentPage]);

    return (
        <div className="page-content ordersMainPage">
            <ToastContainer />
            <Container fluid>
                <BreadCrumb
                    title="Manage Manual Orders"
                    pageTitle="Orders"
                    pageTitleRoute="/manage-products"
                />

                <ConfirmOrderModal
                    show={ConfirmModal}
                    onCloseClick={() => setConfirmModal(false)}
                />

                <Card>
                    <div className="navigatiovCardDv">
                        <h2 >Order History</h2>
                        {counts && (
                            <Nav
                                className="nav-tabs nav-tabs-custom nav-success"
                                role="tablist"
                            >
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: activeTab === "all" })}
                                        href="#"
                                        onClick={() => {
                                            setCurrentPage(1);
                                            onGetOrdersWithStatus(currentPage, "all");
                                            setActiveTab("all");
                                        }}
                                        data-testing-id="all_orders"
                                    >
                                        All Orders
                                        <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                                            {counts.allCount}
                                        </span>
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: activeTab === "newOrder" })}
                                        href="#"
                                        data-testing-id="newOrderTabar_orders"
                                        onClick={() => {
                                            setCurrentPage(1);
                                            onGetOrdersWithStatus(currentPage, "newOrder");
                                            setActiveTab("newOrder");
                                        }}
                                    >
                                        New Orders
                                        <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                                            {counts.newOrderCount}
                                        </span>
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: activeTab === "pending" })}
                                        href="#"
                                        data-testing-id="pendingTabbar_orders"
                                        onClick={() => {
                                            setCurrentPage(1);
                                            onGetOrdersWithStatus(currentPage, "pending");
                                            setActiveTab("pending");
                                        }}
                                    >
                                        Pending
                                        <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                                            {counts.pendingCount}
                                        </span>
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: activeTab === "manualAssigned" })}
                                        href="#"
                                        data-testing-id="manualAssignedTabbar_orders"
                                        onClick={() => {
                                            setCurrentPage(1);
                                            onGetOrdersWithStatus(currentPage, "manualAssigned");
                                            setActiveTab("manualAssigned");
                                        }}
                                    >
                                        Manual Assigned
                                        <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                                            {counts.pendingCount}
                                        </span>
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({
                                            active: activeTab === "readyToShip",
                                        })}
                                        href="#"
                                        data-testing-id="readyToShipTabbar_orders"
                                        onClick={() => {
                                            setCurrentPage(1);
                                            onGetOrdersWithStatus(currentPage, "readyToShip");
                                            setActiveTab("readyToShip");
                                        }}
                                    >
                                        Ready To Ship
                                        <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                                            {counts.readyToShipCount}
                                        </span>
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({
                                            active: activeTab === "shipping",
                                        })}
                                        href="#"
                                        data-testing-id="acceptedTabbar_orders"
                                        onClick={() => {
                                            setCurrentPage(1);
                                            onGetOrdersWithStatus(currentPage, "shipping");
                                            setActiveTab("shipping");
                                        }}
                                    >
                                        Shipping
                                        <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                                            {counts.acceptedCount}
                                        </span>
                                    </NavLink>
                                </NavItem>

                                <NavItem>
                                    <NavLink
                                        className={classnames({
                                            active: activeTab === "cancelledByBuyer",
                                        })}
                                        href="#"
                                        data-testing-id="cancelledByBuyerTabbar_orders"
                                        onClick={() => {
                                            setCurrentPage(1);
                                            onGetOrdersWithStatus(currentPage, "cancelledByBuyer");
                                            setActiveTab("cancelledByBuyer");
                                        }}
                                    >
                                        Cancelled
                                        <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                                            {counts.cancelledByBuyerCount}
                                        </span>
                                    </NavLink>
                                </NavItem>



                                <NavItem>
                                    <NavLink
                                        className={classnames({
                                            active: activeTab === "cancelledBySeller",
                                        })}
                                        href="#"
                                        data-testing-id="rejectedTabbar_campaign"
                                        onClick={() => {
                                            setCurrentPage(1);
                                            onGetOrdersWithStatus(currentPage, "cancelledBySeller");
                                            setActiveTab("cancelledBySeller");
                                        }}
                                    >
                                        Rejected
                                        <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                                            {counts.cancelledBySellerCount}
                                        </span>
                                    </NavLink>
                                </NavItem>



                            </Nav>
                        )}

                        <div className="serchNavigationDv">
                            <div className="serchDv">
                                <i className="bx bx-search"></i>
                                <input
                                    type="text"
                                    placeholder="Search"
                                    data-testing-id="serachInput_order"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                            <div className="paginationDv">
                                <nav aria-label="Page navigation example">
                                    <ul className="pagination detailPagepagi">
                                        <li
                                            className={`page-item ${currentPage === 1 ? "disabled" : ""
                                                }`}
                                        >
                                            <button
                                                className="page-link"
                                                onClick={() =>
                                                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                                                }
                                            >
                                                <i
                                                    className="bx bx-left-arrow-alt fs-2"
                                                    style={{ color: "#A2B1C3" }}
                                                ></i>
                                            </button>
                                        </li>
                                        {Array.from(
                      { length: Math.min(totalPages, 5) },
                      (_, i) => {
                        const startPage = Math.max(
                          Math.min(currentPage - 4, totalPages - 7),
                          1
                        );
                        return startPage + i;
                      }
                    ).map((page) => (
                      <div>
                        <li
                          className={`page-item ${currentPage === page ? "active" : ""}`}
                          key={page}
                        >
                          <button
                            style={{ height: '26px' }}
                            className="page-link orderPg"
                            onClick={() => setCurrentPage(page)}
                          >
                            {page}
                          </button>
                        </li>
                      </div>
                    ))}

                                        <li
                                            className={`page-item ${currentPage === totalPages ? "disabled" : ""
                                                }`}
                                        >
                                            <button
                                                className="page-link orderPg"
                                                onClick={() =>
                                                    setCurrentPage((prev) =>
                                                        Math.min(prev + 1, totalPages)
                                                    )
                                                }
                                            >
                                                <i
                                                    className="bx bx-right-arrow-alt fs-2 cursor-pointer"
                                                    style={{ color: "#A2B1C3" }}
                                                ></i>
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                        <div className="tableHead">
                            <div className="tableHeadChild firtChild">
                                <h4>Product</h4>
                            </div>
                            <div className="tableHeadChild">
                                <h4>Total Amount</h4>
                            </div>
                            <div className="tableHeadChild">
                                <h4>Delivery Type</h4>
                            </div>
                            <div className="tableHeadChild">
                                <h4>Order Status</h4>
                            </div>
                            <div className="tableHeadChild lastChild">
                                <h4>Actions</h4>
                            </div>
                        </div>
                    </div>
                </Card>
                {navigations.label === "All Orders" && (
                    <>
                        {orders && orders.length > 0 ? (
                            orders.map((order: any, index: any) => (
                                <OrderHistoryCard
                                    key={order._id}
                                    order={order}
                                    index={index}
                                    activeTab={activeTab}
                                    setOrders={setOrders}
                                    setTotalPages={setTotalPages}
                                />
                            ))
                        ) : (
                            <h2>No Data Found!</h2>
                        )}
                    </>
                )}
            </Container>
        </div>
    );

};

export default MandualOrder;
